import React from 'react';

import { Tr } from './Tagtable-tr';
import TagTableModal from './Tagtable-modal';
import { cloneObject } from '../../helpers/format';

class TagTable extends React.Component {
  constructor(props){
    super(props);

    this.state = this.buildState(props, {});

    this.handleTagClick = this.handleTagClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(
      this.buildState(nextProps, this.props)
    );
  }

  buildState(nextProps, props) {
    const {
      columns, data,
      regionalGroupFilter,
      assistanceTypeFilter
    } = nextProps;

    const newState = {
      showModal: false,
      modalContent: ''
    };

    if (props.columns !== columns) {
      newState.columns = this.formatColumns(columns);
    }

    if (props.data !== data
      || props.regionalGroupFilter !== regionalGroupFilter
      || props.assistanceTypeFilter !== assistanceTypeFilter
    ) {
      newState.data = this.filterData(data, regionalGroupFilter, assistanceTypeFilter);
    }

    return newState;
  }

  filterByRegionalGroup(data, filter) {
    if (filter === 'GLOBAL') return data;

    return data.filter((item) => {
      return item.regionalGroup === filter;
    });
  }

  filterByFlag(data, filter) {
    return data.map((item) => {
      const newItem = cloneObject(item);

      Object.keys(newItem).forEach(key => {
        const section = newItem[key];

        if (section.flag && section.flag !== filter) {
          section.value = '';
        }
      });

      return newItem;
    });
  }

  filterData(data, regionalGroupFilter, assistanceTypeFilter) {
    let filteredData = data.slice();
    filteredData = this.filterByRegionalGroup(filteredData, regionalGroupFilter);
    filteredData = this.filterByFlag(filteredData, assistanceTypeFilter);
    return filteredData;
  }

  formatColumns(columns) {
    return columns.map(column => {
      let formattedColumn = column;

      if (typeof(formattedColumn) === 'string') {
        formattedColumn = {
          key: column,
          label: column
        };
      } else {
        formattedColumn = Object.assign({}, formattedColumn);
      }

      return formattedColumn;
    });
  }

  handleTagClick(countryName, valueBlob) {
    let modalContent = {...valueBlob};
    modalContent.tagName = modalContent.value;
    modalContent.countryName = countryName;

    modalContent.fullTagName = Object.values(this.props.thematicDict)
      .find(item => {
        return item.abbreviation === modalContent.value;
      }).fullTopicName;

    this.setState({
      showModal: true,
      modalContent
    });
  }

  handleCloseModal() {
    this.setState({
      showModal: false
    });
  }

  renderNoData() {
    return (
      <tr className="reactable-no-data">
        <td colSpan={ this.state.columns.length }>
          { this.props.noDataText }
        </td>
      </tr>
    );
  }

  renderRows() {
    const { data, columns } = this.state,
      { thematicDict, defaultColor } = this.props;

    if (!Array.isArray(data)) return [];

    return data.map((country, index) => {
      const hasProjects = Object.values(country).some(item => {
        return item.value !== '' && item.reportSourceYear;
      });

      if (!hasProjects) return null;

      return (
        <Tr
          columns={ columns }
          key={ index }
          data={ country }
          thematicDict={ thematicDict }
          defaultColor={ defaultColor }
          onTagClick={ this.handleTagClick }
        />
      );
    });
  }

  render() {
    const { showModal, modalContent } = this.state;

    let tableContent = this.renderRows();
    if (tableContent.length === 0) {
      tableContent = this.props.noDataText
        ? this.renderNoData()
        : null;
    }

    return (
      <div>
        <table className={ this.props.className }>
          <tbody>
            { tableContent }
          </tbody>
        </table>

        <TagTableModal
          show={ showModal }
          onHide={ this.handleCloseModal }
          content={ modalContent }
        />
      </div>
    );
  }
}

export default TagTable;



// WEBPACK FOOTER //
// ./src/components/AssistanceLanding/Tagtable.js